import { SvgIcon } from '@mui/material';

export function Cursor() {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M19.813 13L7 3.65v15.812l3.345-4.584 3.106 6.152 3.94-1.981L14.359 13zm-3.764 5.604l-2.155 1.084-3.393-6.72L8 16.395V5.618L16.746 12H12.74z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    </SvgIcon>
  );
}
